import React from 'react';

export const FunnelChallengeIcon = () => (
  <svg data-testid="FunnelChallengeIcon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M14.818,14.3a.758.758,0,0,1,.75.766h0v1.883H19a.768.768,0,0,1,.537,1.3h0l-.079.071-7,5.52a.736.736,0,0,1-.916,0h0l-7-5.52A.768.768,0,0,1,5,16.948H8.431V15.064a.761.761,0,0,1,.648-.759h0l.1-.007Zm-.75,1.532H9.931v1.884a.762.762,0,0,1-.648.759h0l-.1.007H7.2L12,22.266l4.8-3.787H14.818a.756.756,0,0,1-.743-.662h0l-.007-.1ZM18.25,7.149a2.809,2.809,0,0,1,0,5.617H5.75a2.809,2.809,0,0,1,0-5.617h12.5Zm0,1.532H5.75a1.277,1.277,0,0,0,0,2.553h12.5a1.277,1.277,0,0,0,0-2.553ZM21.25,0A2.779,2.779,0,0,1,24,2.809a2.779,2.779,0,0,1-2.75,2.808H2.75A2.779,2.779,0,0,1,0,2.809,2.779,2.779,0,0,1,2.75,0h18.5Zm0,1.532H2.75a1.277,1.277,0,0,0,0,2.553h18.5a1.277,1.277,0,0,0,0-2.553Z"
    />
  </svg>
);
